import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { loginUser } from '../../../services/authentication/login/actions';

import {
    FormComponent,
    EmailInputFieldComponent,
    PasswordInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';

import './LoginFormComponent.scss';

class LoginFormComponent extends React.Component {
    submit = data => {
        const { loginUser, currentPath } = this.props;
        loginUser(data, () => this.props.history.push(currentPath ? currentPath : '/'));
    };

    render() {
        const {
            errorMessage,
            requestSubmit,
            successSubmit,
            errorSubmit,
            i18nForm,
            i18nRegister,
            i18nLogin
        } = this.props;
        if (!successSubmit) {
            return (
                <FormComponent
                    form="login-form"
                    onSubmit={this.submit}
                    requestSubmit={requestSubmit}
                    errorSubmit={errorSubmit}
                    initialValues={{}}
                    className="login-form"
                    submitText={i18nRegister.CONNECT_ME}>
                    <EmailInputFieldComponent
                        name="email"
                        placeholder={i18nForm.PLACEHOLDER_EMAIL}
                        isRequired
                    />
                    <PasswordInputFieldComponent
                        name="password"
                        placeholder={i18nForm.PLACEHOLDER_PASSWORD}
                        isRequired
                    />
                    <LegendFieldComponent classNameInputContainer="small txtright">
                        <LocalizedNavLink to={'/password-reset'}>
                            {i18nForm.PASSWORD_FORGOTTEN}
                        </LocalizedNavLink>
                    </LegendFieldComponent>
                    {errorMessage && (
                        <LegendFieldComponent classNameInputContainer="color-err">
                            {errorMessage}
                        </LegendFieldComponent>
                    )}
                </FormComponent>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18nLogin.LOGIN_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

LoginFormComponent.propTypes = {
    currentPath: PropTypes.string.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        errorMessage: state.authentication.error || '',
        requestSubmit: state.authentication.fetching || false,
        errorSubmit: !isEmpty(state.authentication.error),
        successSubmit: state.authentication.isAuthenticated,
        i18nForm: state.i18n.feature.form,
        i18nRegister: state.i18n.page.register,
        i18nLogin: state.i18n.page.login
    };
};

const mapDispatchToProps = {
    loginUser
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFormComponent.js